// services/errorReporting.js — errors to Sentry, when a DSN is set.
//
// Env-gated and errors-only, as before: no DSN (dev, self-hosters, today's
// production until one is set) means nothing is loaded and nothing is sent;
// tracing stays off so the free quota is spent on real errors.
//
// Loaded on its own, after the page (2026-10-31). The Sentry SDK was in the
// one script every visitor parses before anything paints: about 94 KB of the
// main bundle's 1.1 MB, paid on the landing page by people who will never
// sign in, and paid by everyone when no DSN is set at all. Now it is a chunk
// fetched only when a DSN is set, once the app has started. An error caught
// by an ErrorBoundary before it arrives is held and sent when it does; an
// uncaught error in that first moment is the one thing it no longer sees.

let sentry = null;
const held = [];
const HOLD_MAX = 20;

/** Loads and starts Sentry when a DSN is set. Safe to call more than once. */
let started = false;
export function startErrorReporting(dsn = process.env.REACT_APP_SENTRY_DSN) {
  if (!dsn || started) return;
  started = true;
  import('@sentry/react')
    .then((Sentry) => {
      Sentry.init({ dsn, tracesSampleRate: 0, sendDefaultPii: false });
      sentry = Sentry;
      for (const [error, context] of held.splice(0)) Sentry.captureException(error, context);
    })
    .catch(() => { /* offline or blocked: errors simply are not reported */ });
}

/** Reports one error (an ErrorBoundary's catch). A no-op without a DSN. */
export function reportError(error, context) {
  if (sentry) { sentry.captureException(error, context); return; }
  if (started && held.length < HOLD_MAX) held.push([error, context]);
}
